import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { ISchedule } from '@cbridge-packages/schedule';
import { IScheduleInterval, IScheduleIntervalForm } from './scheduleInterval.interface';

export namespace ScheduleIntervalAction {
  const actionCreator = actionCreatorFactory('ScheduleInterval');

  export const load = actionCreator.async<{ scheduleId: ISchedule['scheduleId'] }, IScheduleInterval[], IApiErrorParams>('LOAD');

  export const viewIntervals = actionCreator<{ scheduleId: ISchedule['scheduleId'] }>('VIEW_INTERVALS');

  interface IIntervalKey {
    scheduleId: ISchedule['scheduleId'];
    index?: number;
  }
  export interface IUpdateIntervalParams extends IIntervalKey {
    interval: IScheduleIntervalForm;
  }

  export const update = actionCreator.async<IUpdateIntervalParams, void, IApiErrorParams>('UPDATE');
  export const remove = actionCreator.async<IIntervalKey, IScheduleInterval[] | void, IApiErrorParams>('REMOVE');

  export const removeSchedule = actionCreator<{ scheduleId: ISchedule['scheduleId'] }>('REMOVE_SCHEDULE');

  export const destroy = actionCreator('DESTROY');
}
